import { Avatar, Badge, Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectSchool } from "../../../redux/school/schoolSlice";
import { selectClassroom } from "../../../redux/classroom/classroomSlice";
import { styled } from "@mui/material/styles";
import { stringAvatar, stringToColor } from "../../../features/user/avatarUtils";
import { assertThumbnailUrl } from "../../../redux/common";

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 20,
  height: 20,
  border: `2px solid ${theme.palette.background.paper}`,
  fontSize: "0.5rem",
}));

interface ClassroomPageAvatarProps {
}

const ClassroomPageAvatar = ({}: ClassroomPageAvatarProps) => {
  const school = useSelector( selectSchool );
  const classroom = useSelector( selectClassroom );

  return (school.selected && classroom.selected) ?
    <Box sx={{ mr: 2 }}>
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        badgeContent={
          <SmallAvatar alt={`${school.selected.name}`} src={`${assertThumbnailUrl(school.selected.url)}`} />
        }>
          <Avatar sx={{ backgroundColor: stringToColor(classroom.selected.name) }} alt={`${classroom.selected.name}`} src={`${assertThumbnailUrl(classroom.selected.url)}`}>
            <Typography variant="h6" component="span">
              {stringAvatar(classroom.selected.name)}
            </Typography>
          </Avatar>
      </Badge>
    </Box>
    : <></>;
};

export default ClassroomPageAvatar;